import {SelectionModel} from '@angular/cdk/collections';
import {Component, Input, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {FormComponent} from "../model/form-component";
import {MyOption, PREDEFINED_OPTIONS} from "../model/dictionary";
import {getKeys, getOptionByKey, hasOptions, initOptions, isTrue, setOption} from "../model/form-component-utils";
import {COMPONENT_TYPES_REGISTRY} from "../model/registry";

@Component({
    selector: 'predefined-options',
    templateUrl: 'predefined.options.component.html',
    styleUrls: ['predefined.options.component.scss'],
})
export class PredefinedOptionsComponent implements OnInit {

    displayedColumns: string[] = ['select', 'key', 'value'];
    matDatasource = new MatTableDataSource<MyOption>();
    validOptions: MyOption[] = [];
    selection = new SelectionModel<MyOption>(true, []);
    isReadOnly: boolean = false;
    isChanged: boolean = false;

    @Input() public formComponent: FormComponent;

    ngOnInit(): void {
        COMPONENT_TYPES_REGISTRY.get(this.formComponent.type).implementedOptions.forEach(key => {
            for (let opt of PREDEFINED_OPTIONS) {
                if (opt.key === key){
                    this.validOptions.push(opt);
                }
            }
        });
        this.matDatasource.data = this.validOptions;
        console.log(this.validOptions);

        // mark Option Used on the validOptions list
        console.log('found options:' + this.formComponent.options);
        console.log(typeof this.formComponent.options);
        if (hasOptions(this.formComponent)) {
            //const map = new Map(Object.entries(this.formComponent.options));
            getKeys(this.formComponent.options).forEach(key => {
                const value = getOptionByKey(this.formComponent, key, undefined);
                console.log('found an option key:' + key);
                console.log('found an option value:' + value);
                const myOption = new MyOption();
                myOption.key = key;
                myOption.value = value;
                this.markAsUsed(myOption);
            });
        }
    }

    markAsUsed(formComponentOption: MyOption): void {
        console.log('Mark as used component option: ');
        console.dir(formComponentOption);

        this.validOptions.forEach(validComponentOption => {
            if (validComponentOption.key === formComponentOption.key) {
                if (formComponentOption.value) {
                    validComponentOption.value = formComponentOption.value;
                }
                this.selection.toggle(validComponentOption);
            }
        });
    }

    isNotEditable(element: MyOption) {
        return !this.selection.isSelected(element) || this.isReadOnly;
    }

    isNumberType(element: MyOption): boolean {
        return element.valueType === Number;
    }

    isStringTypeOrNull(element: MyOption): boolean {
        return !element.valueType || element.valueType === String;
    }

    /**
     * Note: do not use boolean since any type boolean selected translates to true and if not selected translates to false.
     * For more than than 2 values use the predefined values field.
     * @param element
     */
    isBooleanType(element: MyOption): boolean {
        return element.valueType === Boolean;
    }

    isPredefinedValues(element: MyOption): boolean {
        return element.valueType === Selection;
    }

    changed(element: MyOption, key: string, keyValue: any): void {
        this.isChanged = true;
        element[key] = keyValue;
        this.updateOptions();
    }

    toggleSelection(element: MyOption): void {
        this.isChanged = true;
        this.selection.toggle(element);
        this.updateOptions();
    }

    toggled(element: MyOption): void {
        this.isChanged = true;
        console.log('Value change');
        console.log('KeyValue:' + element.value);
        if (this.isStringValueTrue(element.value)) {
            element.value = 'false';
        } else {
            element.value = 'true';
        }
        this.updateOptions();
    }

    isStringValueTrue(value: string): boolean {
        return value !== null && value !== undefined && isTrue(value);
    }

    updateOptions(): void {
        this.formComponent.options = [];
        console.debug('... selected options:' + this.selection.selected.length);
        this.selection.selected.forEach(option => {
            console.log('selected option:' + option.key.toString()+ ' ' + option.value);
            setOption(this.formComponent, option.key.toString(), option.value);
        });
    }

}

